/** Overlay de debug (dev): stats do player, essences, hook e save. */
export interface DebugData {
  fps: number;
  px: number;
  pz: number;
  enemies: number;

  hp: number;
  maxHp: number;
  level: number;
  xp: number;
  xpForNext: number;

  damage: number;
  moveSpeed: number;
  armor: number;
  critChance: number;

  power: number;
  vitality: number;
  agility: number;
  fortitude: number;
  ferocity: number;

  hookState: string;
  hookCd: number;
  saveStatus: string;

  // Fase 7 — zonas de combate
  zone: string;
  distSanctuary: number;
  combatEnabled: boolean;
  targetName: string;

  // Fase 3
  region: string;
  elitesDefeated: number;
  requiredElites: number;
  gateOpen: boolean;
  alphaSoul: number;
  saveVersion: number;
  adds: number;
  bossActive: boolean;
  bossState: string;
  bossAttack: string;
  bossPhase: number;
  bossHp: number;
}

export class DebugOverlay {
  private readonly el: HTMLPreElement;
  private enabled = false;

  constructor(uiRoot: HTMLElement) {
    this.el = document.createElement("pre");
    this.el.className = "debug";
    this.el.hidden = true;
    uiRoot.appendChild(this.el);
  }

  get isEnabled(): boolean {
    return this.enabled;
  }

  toggle(): void {
    this.enabled = !this.enabled;
    this.el.hidden = !this.enabled;
  }

  update(d: DebugData): void {
    if (!this.enabled) return;
    this.el.textContent =
      `DEBUG (F3)\n` +
      `FPS       ${d.fps.toFixed(0)}\n` +
      `pos       ${d.px.toFixed(1)}, ${d.pz.toFixed(1)}\n` +
      `enemies   ${d.enemies}\n` +
      `\n` +
      `HP        ${Math.ceil(d.hp)}/${d.maxHp}\n` +
      `level     ${d.level}   XP ${d.xp}/${d.xpForNext}\n` +
      `damage    ${d.damage}\n` +
      `moveSpeed ${d.moveSpeed.toFixed(2)}\n` +
      `armor     ${d.armor}\n` +
      `crit      ${(d.critChance * 100).toFixed(1)}%\n` +
      `\n` +
      `POW ${d.power}  VIT ${d.vitality}  AGI ${d.agility}\n` +
      `FOR ${d.fortitude}  FER ${d.ferocity}\n` +
      `\n` +
      `hook      ${d.hookState} (cd ${d.hookCd.toFixed(1)})\n` +
      `zone      ${d.zone.toUpperCase()}  combat ${d.combatEnabled ? "ON" : "OFF"}\n` +
      `distSanc  ${d.distSanctuary.toFixed(1)}  target ${d.targetName}\n` +
      `save      ${d.saveStatus} (v${d.saveVersion})\n` +
      `\n` +
      `region    ${d.region}\n` +
      `elites    ${d.elitesDefeated}/${d.requiredElites}   gate ${d.gateOpen ? "OPEN" : "locked"}\n` +
      `alphaSoul ${d.alphaSoul}   adds ${d.adds}\n` +
      (d.bossActive
        ? `\nBOSS      ${d.bossState} / ${d.bossAttack}\n` + `  phase ${d.bossPhase}   hp ${d.bossHp}`
        : "");
  }
}
